import React from 'react';
import { FaChevronDown, FaTimes } from 'react-icons/fa';

function BookmarksDropdown({ onClose }) {
  return (
    <div className="bookmarks-dropdown">
      <div className="dropdown-header">
        <h3>Bookmarks</h3>
        <div className="all-projects">
          All Projects <FaChevronDown />
        </div>
        <FaTimes className="close-icon" onClick={onClose} />
      </div>
      <div className="dropdown-content">
        <div className="no-bookmarks-message">
          <h4>No Bookmarks</h4>
          <p>There are no bookmarks yet. Start by adding your first!</p>
        </div>
      </div>
      <div className="dropdown-footer">
        {/* Can add footer elements here if needed */}
        No Bookmarks
      </div>
    </div>
  );
}

export default BookmarksDropdown; 